import { FC, useState } from 'react';
import PropTypes from 'prop-types';
import { CustomerUser } from 'src/interfaces/user/customer';
import { NoAccountFound } from 'src/components/common/noAccountFound';
import { AddCustomerProfile } from '../dialogs/addCustomerProfile';

interface ResourceUnavailableProps {
  mobileNumber: string;
  addEditCustomerProfile: (data: CustomerUser, isAdd: boolean) => Promise<boolean>;
}

export const CreateProfileCard: FC<ResourceUnavailableProps> = (props) => {
  const { mobileNumber, addEditCustomerProfile } = props;

  const [openAddProfileDialog, setOpenAddProfileDialog] = useState(false);

  const openAddProfile = () => {
    setOpenAddProfileDialog(true);
  };

  return (
    <>
      <NoAccountFound
        onCreate={openAddProfile}
      />
      <AddCustomerProfile
        open={openAddProfileDialog}
        onClose={() => setOpenAddProfileDialog(false)}
        mobileNumber={mobileNumber}
        customerDetails={null}
        addEditCustomerProfile={addEditCustomerProfile}
      />
    </>
  );
};

CreateProfileCard.propTypes = {
  mobileNumber: PropTypes.string,
  addEditCustomerProfile: PropTypes.func
};
